export const routes_publicaciones_previas = [
    {
        path:'/header',
        component:()=> import('./pages/header'),
        children:[
            {
                path: '/previas/publico',
                name: 'process-preview-list',
                component: () => import('./pages/list')
            },{
                path: '/previas/publico/:id',
                name: 'process-preview-list-type',
                component: () => import('./pages/list')
            },
            {
                path: '/previas/detalle/:id',
                name: 'process-preview-delete',
                component: () => import('./pages/detalle')
            }
        ]

    }
]
